import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadContactInfoBlockData from '../../../Models/Content/AbroadContactInfoBlockData';
import AbroadContactInfo from './AbroadContactInfo';

export default class PopupBenefitBlock extends EpiComponent<AbroadContactInfoBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <AbroadContactInfo context={this.getContext()} iContent={this.props.data} />;
  }
}
